'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Automate Paperwork SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Automate Paperwork with eSignatures',
            subtitle: 'Ready to start automating your paperwork with eSignatures?',
            buttonText: 'SIGN UP FREE'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What is HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                _react2['default'].createElement(
                    'a',
                    { href: 'http://www.hellosign.com', target: '_blank', rel: 'noopener noreferrer' },
                    'HelloSign'
                ),
                ' provides fast, secure, and legally-binding eSignatures. Our app is available for use on your desktop, your tablet, or any of your mobile devices.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can use HelloSign to send eSignature requests, track the signing status of any document, and format your online paperwork efficiently and accurately. But most importantly, you can use HelloSign to automate paperwork and save time and valuable resources.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Let\u2019s dive a little deeper...'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How can I use HelloSign to automate my workflow?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign provides an easy way to make signing documents less time-consuming and mentally straining.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here are a few ways eSignatures can be used to automate paperwork flows:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Send signature requests via your email and receive automatic signature notifications.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Create document templates so you don\u2019t have to reformat your frequently used documents.'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Autofill documents with information from a CRM. For an example of CRM data merging, check out our ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://faq.hellosign.com/hc/en-us/articles/212164958-Autofill-HelloSign-Templates-With-a-HubSpot-CRM-Contact-s-Info',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'HubSpot CRM integration FAQ.'
                    )
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'HelloSign also works with other commonly used applications to make signing in whatever program you\u2019re in as simple as possible. We\u2019re happy to integrate with companies like ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://hellosign.com/gmail',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Google'
                ),
                ', ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/dropbox/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Dropbox'
                ),
                ', and ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://hellosign.com/slack', target: '_blank', rel: 'noopener noreferrer' },
                    'Slack'
                ),
                '(to name a few).'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Why is paperwork automation important?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Imagine that you need to get an important document signed by the end of the day, but the stakeholder is out of the office. The traditional way of signing paper would require you to print the document, scan it over to them, and then wait for your partner print, sign, and fax back to you.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Now imagine if you could just send the document to your partner via email. They could open the doc and sign directly in their email account. You\u2019d get a notification when they\u2019ve signed and the completed form would automatically download to your account. This saves hours of admin work and reduces unnecessary back and forth.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'eSignatures simplify the signing process.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Are eSignatures legal?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes, eSignatures are considered a legal form of signature by all fifty states in the US and most other countries.  ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures/',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'You can learn more about the legality of eSignatures here'
                ),
                '.  HelloSign signatures are secure and protected on all fronts. Here are just a few of the security checkpoints:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Secure data storage'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'SSL hosting'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Audit-trails with time stamps'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Features like two-factor authentication'
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                _react2['default'].createElement(
                    'a',
                    { href: 'https://www.hellosign.com/info/security',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'Learn more about the security of HelloSign eSignatures here.'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What industries are using HelloSign?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Most industries that deal with paperwork in some way or form have taken their paperwork online. Whether the majority of your documents are internal (like onboarding paperwork) or external (sales contracts), there\u2019s growing need to make the paperwork process as simple and seamless as possible.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here are just a few examples of industries who have benefitted from taking their paperwork online:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Real estate'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Insurance'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sales'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'HR'
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'It\’s easy to start automating paperwork with HelloSign. Simply link your Google account to set up a free HelloSign plan and  start sending eSignature requests in minutes. Unlimited documents are included in any Pro and above plan.',
            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/automate-paperwork.jsx
 ** module id = 1216
 ** module chunks = 0
 **/